module.exports = __webpack_public_path__ + "img/st.0f059d01.svg";